const buildListNameQuery = (query, listName) => {
  if (!listName) return query;
  const updatedQuery = {};
  const listKey = `pb[${listName}]`;
  Object.keys(query).forEach(queryKey => {
    const isListKey = queryKey.indexOf(`${listName}`) !== -1;
    if (!isListKey) return;
    const decodedQueryValue = Array.isArray(query[queryKey])
      ? query[queryKey].map(value => decodeURIComponent(value))
      : decodeURIComponent(query[queryKey]);
    const strippedKey = queryKey.substring(listKey.length + 1, queryKey.length - 1);
    if (isListKey) updatedQuery[strippedKey] = decodedQueryValue;
  });

  return updatedQuery;
};

export default buildListNameQuery;
